import { Link } from 'gatsby'
import React from 'react'
import { ResourcesHeadlineProps } from '../../types'
import { classNames } from '../../utils'

export const ResourceHeadline = ({
  title,
  tags,
  date,
  linkTo,
  customClasses,
}: ResourcesHeadlineProps): JSX.Element => {
  return (
    <div className={classNames('@container', customClasses)}>
      <div className={classNames('flex flex-col pt-m @lg:flex-row')}>
        <div className="mb-s min-w-36 text-xs leading-none text-default-400">
          {date}
        </div>
        <div className="flex flex-col items-start gap-m">
          <Link to={linkTo}>
            <h3 className="text-xl font-bold leading-snug text-default-50 hover:text-primary-500">
              {title}
            </h3>
          </Link>
          <div className="flex flex-wrap gap-xxs">
            {tags &&
              tags.map((subCatName) => (
                <Link
                  key={subCatName.id}
                  to={`/resources/tag/${subCatName.slug}`}
                  className={classNames(
                    'h-4 items-center justify-center rounded border border-default-800 bg-default-800 px-xs py-xxxs text-xxxxs !leading-none text-default-50 hover:border-primary hover:bg-primary hover:text-default-1000'
                  )}
                >
                  {subCatName.name}
                </Link>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}
